import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { IsActive } from './../../../../model';
import { environment } from './../../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import * as HttpStatus from 'http-status-codes';

@Injectable()
export class EquipmentSummaryService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient
  ) { }

  getSummary(siteId: Observable<any>, customerId: Observable<any>, activeFilter: number) {
    let url;
    let prefix;
    if (siteId != null) {
      prefix = 'sites/' + siteId + '/equipment-summary?';
    } else if (customerId != null) {
      prefix = 'customers/' + customerId + '/equipment-summary?';
    } else {
      prefix = 'equipments?';
    }
    url = this.urlPrefix + prefix + 'status=' + activeFilter;

    return this.http
      .get(url, {
        observe: 'response'
      })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  public getMergedEquipmentSummaryByIds(jobNumbers: string[], equipmentNumbers: number[]): Observable<any> {
    const getEquipmentListUrl = this.urlPrefix + 'equipments/equipment-summary/job/equipment';
    const payload = {
      jobEquipmentListModel : equipmentNumbers.map(id => {
        return {
          equipmentId: id,
          jobNumber: jobNumbers
        };
      })
    };
    return this.http
      .post(getEquipmentListUrl, payload, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  getSummaryByIds(equipmentIds: number[]): Observable<any> {
    const getUrl = this.urlPrefix + 'equipments/equipment-summary';
    return this.http
      .post(getUrl, {
        equipmentIdsModel: equipmentIds
      }, {
          observe: 'response'
      })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  getForms(): Observable<any>  {
    const url = this.urlPrefix + 'forms';
    return this.http
      .get(url, {
        observe: 'response'
      })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  public copy(equipmentId, number, siteId): Observable<any> {
    const url = this.urlPrefix + 'equipments/'+equipmentId+'/copy/'+number+'/?site='+siteId;
    return this.http
      .post(url, {}, { observe: 'response' })
      .map(
        res => {
          if (res.status === HttpStatus.CREATED) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  public migrate(equipmentIds, siteId): Observable<any> {
    const url = this.urlPrefix + 'equipments/migrate';
    return this.http
      .post(url, {
        equipmentIds: equipmentIds,
        siteId: siteId,
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-summary/equipment-summary.service.ts